var bighouse = bighouse || {};

bighouse.accordion = (function () {


    function init() {

        if ($('.Accordion').length <= 0)
            return;


        /* Open the first section on load */
      //  $(".Accordion-sectionTitle:first").addClass('open');

        var AccordionSection = '.Accordion-section';
        var AccordionTitle = '.Accordion-sectionExpander';
        var AccordionPanel = '.Accordion-sectionPanel';
        

        //add aria-hidden to all
        //add aria-labelled by etc to all

        $('.Accordion').find(AccordionSection).each(function (index) {
            var theSection = this;
            var theTitle = $(theSection).find(AccordionTitle);
            var thePanel = $(theSection).find(AccordionPanel);


            $(theTitle).attr("id", "Accordion-sectionExpander" + index);
            $(theTitle).attr("aria-controls", "Accordion-panel" + index);

            $(thePanel).attr("id", "Accordion-panel" + index);
            $(thePanel).attr("aria-labelledby", "Accordion-sectionExpander" + index);

            if ($(theSection).hasClass('Accordion-section--show')) {
                $(thePanel).attr("aria-hidden", "false");
            } else {
                $(thePanel).attr("aria-hidden", "true");
            }



            $(theTitle).on('click', function(e){
                if ($(theSection).hasClass('Accordion-section--show')) {
                    $(theSection).removeClass('Accordion-section--show');
                    $(thePanel).attr("aria-hidden", "true");
                } else {
                    $(theSection).addClass('Accordion-section--show');
                    $(thePanel).attr("aria-hidden", "false");
                }
                
                e.preventDefault();
            });


        });


/*


        $('.Accordion').each(function () {

            var self = this;

            $(self).find(AccordionTitle).on('click', function (e) {

                var thisID = $(this).attr('aria-controls');

                if ($(this).hasClass('Accordion-sectionExpander--show')) {

                    //Close the current section
                    $(this).removeClass('Accordion-sectionExpander--show');
                    $(self).find('#' + thisID).attr("aria-hidden", "true").removeClass('Accordion-sectionPanel--show');

                } else {
                    //close the prev section & open the newly click

                    if ($(self).parents('Accordion').hasClass('Accordion-anyOpen')) {
                        $(self).find(AccordionTitle).removeClass('Accordion-sectionExpander--show');
                        $(self).find(AccordionPanel).attr("aria-hidden", "true").removeClass('Accordion-sectionPanel--show');
                    }

                    $(this).addClass('Accordion-sectionExpander--show');
                    var sectionToOpen = $(self).find('#' + thisID);
                    $(sectionToOpen).attr("aria-hidden", "false").addClass('Accordion-sectionPanel--show');
                }

                e.preventDefault();
            });
        });
*/

    }


    return {
        init: init
    };
})();